import React from "react";
import UnityGamePublic from "~/components/UnityGamePublic";

type GameEmbedProps = {
  buildPath: string;
  className?: string;
  style?: React.CSSProperties;
};

export default function GameEmbed({
  buildPath,
  className,
  style,
}: GameEmbedProps) {
  if (!buildPath) {
    return <p> Game unavailable.</p>;
  }
  return (
    <div
      className={"game-display-container-row " + (className ?? "")}
      style={style}
    >
      <UnityGamePublic buildPath={buildPath} />
    </div>
  );
}
